var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDerelictHouse(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 43,
    viewBox: "0 0 36 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#6a462f;}.cls-2{fill:#ea5a47;}.cls-3{fill:#fff;}.cls-4{fill:#92d3f5;}.cls-5{fill:#a57939;}.cls-6{fill:#9b9b9a;}.cls-7{stroke-width:1.99998px;}.cls-7,.cls-8{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;}.cls-8{stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "emoji"
  }, /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 0.5,
    y: 17.5,
    width: 35,
    height: 25
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "10.5 8.0588 5.5 12.7647 5.5 3 10.5 3 10.5 8.0588"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 7.5,
    y: 26,
    width: 9,
    height: 16
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "19.45 26.3798 6.26 39.5698 3.34 36.6598 7.5 32.4998 14 25.9998 16.53 23.4698 19.45 26.3798"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "30 33 24.7924 33 22 33 22 26 24 26 30 26 30 33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "24.7917 33 28 29 25 28 24 26 30 26 30 33 24.7917 33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "18 1 1 17 1 18.0003 35 18.0003 35 17 29 12 22 13 14 14 16 10 14 8 20.6 3.6 18 1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "10.5 8.0588 5.5 12.7647 5.5 3 10.5 3 10.5 8.0588"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "14 25.9998 7.5 32.4998 7.5 25.9998 14 25.9998"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "16.5 29.3298 16.5 41.9998 7.5 41.9998 7.5 38.3298 16.5 29.3298"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "30 33 24.7924 33 22 33 22 26 24 26 30 26 30 33"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 2.06738,
    y: 29.45721,
    width: 18.65562,
    height: 4.12196,
    transform: "translate(-18.94915 17.28908) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "24.7917 33 28 29 25 28 24 26 30 26 30 33 24.7917 33"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 24,
    y1: 8,
    x2: 24,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 27,
    y1: 11,
    x2: 27,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 21,
    y1: 5,
    x2: 21,
    y2: 12
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "22 5 18 1 1 17 1 18.0003 35 18.0003 35 17 29 12 22 13 14 14 16 10 14 8 20.6 3.6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 18,
    y1: 6,
    x2: 18,
    y2: 13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 1,
    y: 18,
    width: 34,
    height: 24
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDerelictHouse);
export default __webpack_public_path__ + "static/media/derelict-house.5efdf4fa16e01824527607400a5d053f.svg";
export { ForwardRef as ReactComponent };